module.exports = __webpack_public_path__ + "img/soundCustomization.3dd30ba0.png";